import Vue from "vue";
import Router from "vue-router";
import Login from "@/pages/login/login";
import Index from "@/pages/home/index";
import home from "@/pages/homepage/home";

import taskMap from "@/pages/homepage/taskMap";
import timeFault from "@/pages/homepage/timeFault";

import contract from "@/pages/contract/list";

import spotCheckPage from "@/pages/spotCheck/spotCheckPage";
import spotResumePage from "@/pages/spotCheck/spotResumePage";
import spotCountPage from "@/pages/spotCheck/spotCountPage";
import spotDeletePage from "@/pages/spotCheck/spotDeletePage";
import spotCheckEmail from "@/pages/spotCheck/spotCheckEmail";

import maintainPlanPage from "@/pages/maintenance/maintainPlanPage";
import maintainResumePage from "@/pages/maintenance/maintainResumePage";
import maintainCountPage from "@/pages/maintenance/maintainCountPage";

import malfunctionRepairPage from "@/pages/malfunction/malfunctionRepairPage";
import malfunctionCountPage from "@/pages/malfunction/malfunctionCountPage";
import malfunctionResumePage from "@/pages/malfunction/malfunctionResumePage";
import malfunctionKnowledgePage from "@/pages/malfunction/malfunctionKnowledgePage";

import fileFactory from "@/pages/file/fileFactory";
import deviceTypePage from "@/pages/file/deviceTypePage";
import deviceFilePage from "@/pages/file/deviceFilePage";

import rolePage from "@/pages/basic/rolePage";
import stationPage from "@/pages/basic/stationPage";
import timePage from "@/pages/basic/timePage";
import userPage from "@/pages/basic/userPage";
import riskPage from "@/pages/basic/riskPage";
import dictPage from "@/pages/basic/dictPage";
import i18nPage from "@/pages/basic/i18nPage";
import paramPage from "@/pages/basic/paramPage";
import customerPage from "@/pages/basic/customerPage";
import warningTimePage from "@/pages/basic/warningTimePage";
import organization from "@/pages/basic/organization";
import outRecord from "@/pages/part/outRecord";
import partInfo from "@/pages/part/partInfo";
import ceshi from "@/pages/ceshi/ceshi";
import ceshi2 from "@/pages/ceshi/ceshi2";
import stock from "@/pages/part/stock";
import locationManagement from "@/pages/part/locationManagement";
import Warehousing from "@/pages/part/Warehousing";
import exwarehouse from "@/pages/part/exwarehouse";
import inventoryTask from "@/pages/part/inventoryTask";
import inventoryRecord from "@/pages/part/inventoryRecord";

import EquipmentInspection from "@/pages/dailyInspection/EquipmentInspection";
import InspectionRecord from "@/pages/dailyInspection/InspectionRecord";
import InspectionStatistics from "@/pages/dailyInspection/InspectionStatistics";

import causeStatistics from "@/pages/statisticalAnalysis/causeStatistics";
import sparePartsStatistics from "@/pages/statisticalAnalysis/sparePartsStatistics";
import equipmentDesign from "@/pages/statisticalAnalysis/equipmentDesign";
import faultStatistics from "@/pages/statisticalAnalysis/faultStatistics";
import checkStatistics from "@/pages/statisticalAnalysis/checkStatistics";
import maintenanceStatistics from "@/pages/statisticalAnalysis/maintenanceStatistics";
import signalLamp from "@/pages/equipmentOperation/signalLamp";
import quipmentMonitoring from "@/pages/equipmentOperation/quipmentMonitoring";

import planResume from "@/pages/transformationAdmin/planResume";
import transformationStatistics from "@/pages/transformationAdmin/transformationStatistics";

import Dashboard from "@/pages/equipmentOperation/Dashboard";
import kpiStatistics from "@/pages/equipmentOperation/kpiStatistics";
import mobileAnalysis from "@/pages/equipmentOperation/mobileAnalysis";

import malfunctionApprove from "@/pages/approve/malfunctionApprove.vue";
import malfunctionApproveView from "@/pages/approve/malfunctionApproveView.vue";
import operlog from "@/pages/monitor/operlog";
import server from "@/pages/monitor/server";
import cache from "@/pages/monitor/cache";

Vue.use(Router);

export function resetRouter() {
  const newRouter = createRouter();
  Router.matcher = newRouter.matcher; // 重新设置路由的可匹配路径
}
export default new Router({
  mode: "history",
  routes: [
    {
      path: "*", //当url不存在 自动跳转到focus
      redirect: "/login"
    },
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/spotCheckEmail",
      name: "spotCheckEmail",
      component: spotCheckEmail,
      // meta: {
      //   requiresAuth: false, // 明确标记不需要认证
      //   isPublic: true, // 添加公共页面标识
      //   hideMenu: true
      // }
    },
    {
      path: "/deviceFilePageCeshi",
      name: "deviceFilePage",
      component: deviceFilePage
    },
    {
      path: "/static",
      name: "index",
      component: Index,
      children: [
        {
          path: "/static/home",
          name: "home",
          component: home
        },
        {
          path: "/static/timeFault",
          name: "timeFault",
          component: timeFault
        },
        {
          path: "/static/taskMap",
          name: "taskMap",
          component: taskMap
        },
        {
          path: "/static/malfunctionCountPage",
          name: "malfunctionCountPage",
          component: malfunctionCountPage
        },
        {
          path: "/static/contract",
          name: "contract",
          component: contract
          // }, {
          // 	path: '/static/ceshi',
          // 	name: 'ceshi',
          // 	component: ceshi
          // }, {
          // 	path: '/static/ceshi2',
          // 	name: 'ceshi2',
          // 	component: ceshi2
        },
        {
          path: "/static/malfunctionResumePage",
          name: "malfunctionResumePage",
          component: malfunctionResumePage
        },
        {
          path: "/static/malfunctionKnowledgePage",
          name: "malfunctionKnowledgePage",
          component: malfunctionKnowledgePage
        },
        {
          path: "/static/malfunctionRepairPage",
          name: "malfunctionRepairPage",
          component: malfunctionRepairPage
        },
        {
          path: "/static/maintainPlanPage",
          name: "maintainPlanPage",
          component: maintainPlanPage
        },
        {
          path: "/static/fileFactory",
          name: "fileFactory",
          component: fileFactory
        },
        {
          path: "/static/deviceFilePage",
          name: "deviceFilePage",
          component: deviceFilePage
        },
        {
          path: "/static/deviceTypePage",
          name: "deviceTypePage",
          component: deviceTypePage
        },
        {
          path: "/static/maintainCountPage",
          name: "maintainCountPage",
          component: maintainCountPage
        },
        {
          path: "/static/maintainResumePage",
          name: "maintainResumePage",
          component: maintainResumePage
        },
        {
          path: "/static/spotCheckPage",
          name: "spotCheckPage",
          component: spotCheckPage
        },
        //   {
        //     path: "/static/spotCheckEmail",
        //     name: "spotCheckEmail",
        //     component: spotCheckEmail,
        //     meta: {
        //       requiresAuth: false, // 明确标记不需要认证
        //       isPublic: true, // 添加公共页面标识
        // hideMenu: true
        //     }
        //   },
        {
          path: "/static/spotCountPage",
          name: "spotCountPage",
          component: spotCountPage
        },
        {
          path: "/static/spotDeletePage",
          name: "spotDeletePage",
          component: spotDeletePage
        },
        {
          path: "/static/spotResumePage",
          name: "spotResumePage",
          component: spotResumePage
        },
        {
          path: "/static/rolePage",
          name: "rolePage",
          component: rolePage
        },
        {
          path: "/static/stationPage",
          name: "stationPage",
          component: stationPage
        },
        {
          path: "/static/timePage",
          name: "timePage",
          component: timePage
        },
        {
          path: "/static/userPage",
          name: "userPage",
          component: userPage
        },
        {
          path: "/static/riskPage",
          name: "riskPage",
          component: riskPage
        },
        {
          path: "/static/dictPage",
          name: "dictPage",
          component: dictPage
        },
        {
          path: "/static/i18nPage",
          name: "i18nPage",
          component: i18nPage
        },
        {
          path: "/static/paramPage",
          name: "paramPage",
          component: paramPage
        },
        {
          path: "/static/customerPage",
          name: "customerPage",
          component: customerPage
        },
        {
          path: "/static/warningTimePage",
          name: "warningTimePage",
          component: warningTimePage
        },
        {
          path: "/static/organization",
          name: "organization",
          component: organization
        },
        {
          path: "/static/outRecord",
          name: "outRecord",
          component: outRecord
        },
        {
          path: "/static/partInfo",
          name: "partInfo",
          component: partInfo
        },
        {
          path: "/static/stock",
          name: "stock",
          component: stock
        },
        {
          path: "/static/locationManagement",
          name: "locationManagement",
          component: locationManagement
        },
        {
          path: "/static/Warehousing",
          name: "Warehousing",
          component: Warehousing
        },
        {
          path: "/static/exwarehouse",
          name: "exwarehouse",
          component: exwarehouse
        },
        {
          path: "/static/inventoryTask",
          name: "inventoryTask",
          component: inventoryTask
        },
        {
          path: "/static/inventoryRecord",
          name: "inventoryRecord",
          component: inventoryRecord
        },
        {
          path: "/static/EquipmentInspection",
          name: "EquipmentInspection",
          component: EquipmentInspection
        },
        {
          path: "/static/InspectionRecord",
          name: "InspectionRecord",
          component: InspectionRecord
        },
        {
          path: "/static/InspectionStatistics",
          name: "InspectionStatistics",
          component: InspectionStatistics
        },
        {
          path: "/static/causeStatistics",
          name: "causeStatistics",
          component: causeStatistics
        },
        {
          path: "/static/sparePartsStatistics",
          name: "sparePartsStatistics",
          component: sparePartsStatistics
        },
        {
          path: "/static/checkStatistics",
          name: "checkStatistics",
          component: checkStatistics
        },
        {
          path: "/static/equipmentDesign",
          name: "equipmentDesign",
          component: equipmentDesign
        },
        {
          path: "/static/faultStatistics",
          name: "faultStatistics",
          component: faultStatistics
        },
        {
          path: "/static/maintenanceStatistics",
          name: "maintenanceStatistics",
          component: maintenanceStatistics
        },
        {
          path: "/static/signalLamp",
          name: "signalLamp",
          component: signalLamp
        },
        {
          path: "/static/quipmentMonitoring",
          name: "quipmentMonitoring",
          component: quipmentMonitoring
        },
        {
          path: "/static/planResume",
          name: "planResume",
          component: planResume
        },
        {
          path: "/static/transformationStatistics",
          name: "transformationStatistics",
          component: transformationStatistics
        },
        {
          path: "/static/Dashboard",
          name: "Dashboard",
          component: Dashboard
        },
        {
          path: "/static/kpiStatistics",
          name: "kpiStatistics",
          component: kpiStatistics
        },
        {
          path: "/static/mobileAnalysis",
          name: "mobileAnalysis",
          component: mobileAnalysis
        },
        {
          path: "/static/malfunctionApprove",
          name: "malfunctionApprove",
          component: malfunctionApprove
        },
        {
          path: "/static/malfunctionApproveView",
          name: "malfunctionApproveView",
          component: malfunctionApproveView
        },
        {
          path: "/operlog",
          name: "operlog",
          component: operlog
        },
        {
          path: "/server",
          name: "server",
          component: server
        },
        {
          path: "/cache",
          name: "cache",
          component: cache
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js